export default {
  // --- order-meta.tsx ---
  "Order ID": "ID de la Commande",
  Customer: "Client",
  Status: "Statut",
  "Delivery Status": "Statut de Livraison",
  "Net Amount": "Montant Net",
  "Created At": "Créé le",
  Actions: "Actions",
  Pending: "En Attente",
  Confirmed: "Confirmé",
  Cancelled: "Annulé",
  Completed: "Terminé",
  Shipped: "Expédié",
  Delivered: "Livré",
  Cash: "Espèces",
  Card: "Carte",
  Mobile: "Mobile",
  Online: "En Ligne",
  Shop: "Boutique",
  "Payment Method": "Méthode de Paiement",
  "Receipt ID": "ID du Reçu",
  "Invoice ID": "ID de la Facture",
  "Amount Paid": "Montant Payé",
  "Change Given": "Monnaie Rendue",
  "Delivery Fee": "Frais de Livraison",
  Discount: "Remise",
  Profit: "Profit",
  "Orders Person ID": "ID de la Personne Responsable",
  User: "Utilisateur",
  Sale: "Vente",

  // --- order-form.tsx ---
  "Customer ID": "ID du Client",
  "Shop ID": "ID de la Boutique",

  // --- select-order.tsx ---
  Order: "Commande",
  "Search order by ID, customer, or shop":
    "Rechercher la commande par ID, client ou boutique",
  "Edit Selection": "Modifier la Sélection",
  "No orders found": "Aucune commande trouvée",

  // --- order-modals/create-order-modal.tsx ---
  "Create a new order": "Créer une nouvelle commande",

  // --- order-modals/edit-order-modal.tsx ---
  "Edit Order": "Modifier la Commande",

  // --- order-modals/view-order-modal.tsx ---
  "General Information": "Informations Générales",
  Sales: "Ventes",
  "Updated At": "Mis à jour le",

  // --- order-modals/delete-order-modal.tsx ---
  "Do you really want to delete this Order?":
    "Voulez-vous vraiment supprimer cette commande ?",
  "Warning: This action is irreversible and may lead to cascade deletions.":
    "Attention : Cette action est irréversible et peut entraîner des suppressions en cascade.",
  Cancel: "Annuler",
  "Confirm Deletion": "Confirmer la Suppression",

  // --- order-list-block.tsx ---
  "Add order": "Ajouter une commande",
  "Total Orders": "Total des commandes",
  "total orders": "total des commandes",
  "Total Revenue": "Revenu total",
  "total revenue": "revenu total",
  "Completed Orders": "Commandes terminées",
  "completed orders": "commandes terminées",
  "Pending orders": "Commandes en attente",
  "pending orders": "commandes en attente",
  "Cancelled orders": "Commandes annulées",
  "cancelled orders": "commandes annulées",
  "Order updated with succes": "Commande mise à jour avec succès",
  Back: "Retour",
  back: "retour",
  "Save changes": "Enregistrer les modifications",
  "Print A5 Receipt": "Imprimer reçu A5",
  "Print A6 Receipt": "Imprimer reçu A6",
  customer: "client",
  Date: "Date",
  date: "date",
  "Serve by": "Servi par",
  status: "statut",
  "Delete order": "Supprimer la commande",
  "Add Payment": "Ajouter un paiement",
  "Total Amount": "Montant total",
  "Total purchasing price": "Prix d'achat total",
  "Delivery fee": "Frais de livraison",
  discount: "remise",
  Tax: "Taxe",
  tax: "taxe",
  profit: "bénéfice",
  Clipboard: "Presse-papiers",
  clipboard: "presse-papiers",
  "Copy to clipboard": "Copier dans le presse-papiers",
  System: "Système",
  system: "système",
};
